<template>
  <el-row style="width: 100%;margin-top: 87px;">
    <!--  轮播图  -->
    <el-row style="height: 660px;">
      <el-carousel :interval="4000" trigger="click" arrow="always" height="660px">
        <el-carousel-item v-for="(item, i) in imgList" :key="i">
          <el-row :style="{backgroundImage: 'url(' + item + ')', width: '100%', height: '100%', backgroundSize:'100% 100%', backgroundRepeat:'no-repeat'}">
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
    <!--  新闻资讯  -->
    <el-row style="width: 64%;margin-left: 18%;margin-top: 40px;display: flex;">
      <el-col style="width: 26%;border-right: 1px solid #5e5e5e;">
        <el-row v-for="(data, i) in dataList" :key="i" :class="i === selMenu ? 'menu-class-hover' : 'menu-class'" @click.native="clickMenu(i)">
          {{data.name}}
        </el-row>
      </el-col>
      <el-col style="width: 67%;margin-left: 7%;text-align: left;">
        <el-row v-show="!showDetail">
          <el-row v-for="(item, i) in newsList" :key="i" class="title-class" @click.native="clickNews(item.id)">
            <el-col span="20" style="white-space:nowrap;text-overflow:ellipsis;overflow: hidden;">
              {{item.titleName}}
            </el-col>
            <el-col span="4" style="text-align: right;">
              {{item.createTime}}
            </el-col>
          </el-row>
          <el-row style="height: 40px;width: 100%;text-align: right;margin-top: 20px;">
            <el-pagination background layout="total, prev, pager, next" :page-size="15" @current-change="pageChange"
                           :current-page="pageInfo.pageNum" :page-count="pageInfo.pages" :total="pageInfo.total" />
          </el-row>
        </el-row>
        <el-row v-show="showDetail">
          <el-row style="font-size: 26px;text-align: center;height: 60px;">{{titleName}}</el-row>
          <el-row style="font-size: 16px;height: 40px;line-height: 40px;text-align: right;color: gray;">发布日期: {{createTime}}</el-row>
          <el-row v-for="(detail, i) in detailList" :key="i">
            <div v-if="detail.contentType === 0" style="line-height: 30px;white-space: pre-wrap;text-align: justify;text-indent: 2em;">{{detail.content}}</div>
            <el-row v-else-if="detail.contentType === 1" style="margin-top: 16px;margin-bottom: 16px;width: 100%;display: flex;justify-content: center;">
              <el-image :src="getImageUrl(detail.content)"></el-image>
            </el-row>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
import axios from 'axios'
export default {
  name: 'NewsPage',
  data() {
    return {
      imgList: [require('../../assets/img/news/news.jpg')],
      dataList: [
        {
          id: '231',
          name: '公司新闻',
          type: 0
        },
        {
          id: '232',
          name: '行业动态',
          type: 1
        }
      ],
      selMenu: 0,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pages: 0
      },
      newsList: [],
      titleName: '',
      createTime: '',
      detailList: [],
      showDetail: false
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.dealIntoPage()
  },
  watch: {
    $route: {
      handler() {
        this.dealIntoPage()
      },
      deep: true
    }
  },
  methods: {
    clickMenu(i) {
      this.selMenu = i
      if (this.$route.query.id) {
        this.$router.push({path: this.$route.path})
      } else {
        this.doQuery(1)
        this.showDetail = false
      }
    },
    doQuery(page) {
      let param = {page: page, rows: 15, newsType: this.dataList[this.selMenu].type}
      this.$api.newsManage.getNewsInfo(param).then(res => {
        this.newsList = res.data.rows
        this.pageInfo.total = res.data.total
        this.pageInfo.pageNum = res.data.pageNum
        this.pageInfo.pages = res.data.pages
      })
    },
    clickNews(id) {
      this.$router.push({path: this.$route.path, query: {id: id}})
    },
    getImageUrl(id) {
      return '/myApi/newsInfo/getImageById?id=' + id
    },
    pageChange(page) {
      this.doQuery(page)
    },
    dealIntoPage() {
      if (this.$route.query.id) {
        let param = {id: this.$route.query.id}
        this.$api.newsManage.getNewsDetail(param).then(res => {
          if (res.code !== 500) {
            this.detailList = res.data.detail
            this.titleName = res.data.titleName
            this.createTime = res.data.createTime
            this.selMenu = res.data.newsType
            this.showDetail = true
          }
        })
      } else {
        this.doQuery(1)
        this.showDetail = false
      }
    }
  }
}
</script>

<style scoped>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .menu-class {
     width: 85%;
     margin-top: 10px;
     height: 40px;
     line-height: 40px;
     background-color: #efefef;
     color: #000000;
     cursor: pointer;
   }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .title-class {
    height: 60px;
    line-height: 60px;
  }
  .title-class:hover {
    cursor: pointer;
    color: #00bf86;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsPage.vue